/* eslint-disable no-case-declarations */
import axios from 'axios';
import { call, takeEvery } from 'redux-saga/effects';
import { getDevice, getPage, getShop } from '../../../../common/pageData';
import {
  getEmbeddedOfferID,
  getOfferID,
  getOrderID,
} from '../../../../common/settings';
import { SUBMIT_EVENT, SEND_EVENT_API } from '../constants';
import { logger } from '../../../../common/logger';

function* sendEventWorker(action) {
  try {
    const data = getEventRequestBody(action);
    const httpArgs = [SEND_EVENT_API, data];
    yield call(axios.post, ...httpArgs);
  } catch (e) {
    logger.log('failed to send event', e);
  }
}

export default function* sendEventWatcher() {
  yield takeEvery(SUBMIT_EVENT, sendEventWorker);
}

const getEventRequestBody = params => {
  const {
    name,
    action,
    primary,
    offered,
    variables,
    added,
    isEmbedded,
    isProductPage,
    // note: offerType is available only for embedded offers
    offerType,
  } = params;

  const event = {
    name,
    action,
    primary,
    offered,
    added,
    device: getDevice(),
    mr_order_id: getOrderID(),
    mr_offer_id: isEmbedded
      ? getEmbeddedOfferID(isProductPage, offerType)
      : getOfferID(),
    shop_url: getShop(),
    page: getPage(),
  };

  variables &&
    variables.forEach((element, idx) => {
      const key = 'variable'.concat((idx + 1).toString());
      event[key] = element.value;
    });
  return event;
};
